import React, { PureComponent } from "react";
import { FormattedHTMLMessage } from "react-intl";

import { scrollTo } from "./services/utils";

import Product from "./Product";
import Loader from "./Loader";
import Error from "./Error";

import "./Products.css";

const getProductDuration = product => {
  if (product.structure !== undefined) {
    const found = product.structure.find(item => item.schedule !== undefined);
    return found !== undefined ? found.schedule.days : 1;
  }
  return product.schedule !== undefined ? product.schedule.days : 1;
};
const sortProduct = (a, b) => {
  const aDuration = getProductDuration(a);
  const bDuration = getProductDuration(b);

  if (aDuration === bDuration) return 0;
  if (aDuration < bDuration) return 1;

  return -1;
};

const computeProducts = products =>
  products.map(
    element => ({ ...element, products: element.products.sort(sortProduct) }),
    []
  );

export default class Products extends PureComponent {
  state = {};

  sortProducts() {
    const { products } = this.props;
    if (products !== undefined) {
      const sortedProducts = computeProducts(products);
      this.setState({ products: sortedProducts }, () => scrollTo(this.element));
    }
  }

  componentDidMount() {
    this.sortProducts();
  }
  componentDidUpdate(prevProps) {
    const { products } = this.props;
    if (products !== prevProps.products) {
      this.sortProducts();
    }
  }
  renderProducts() {
    const { product, technicalError, onChanged } = this.props;
    const { products } = this.state;

    if (products === undefined && !technicalError) {
      return <Loader loading={true} />;
    }

    if (products !== undefined && products.length > 0) {
      return products.map((element, index) => (
        <div key={index}>
          <div className="cm-products--day-title">{element.start}</div>
          {element.products.map(p => {
            return (
              <Product
                start={element.start}
                key={p.code}
                product={p}
                selected={product === p.code}
                onChanged={onChanged}
              />
            );
          })}
        </div>
      ));
    }

    return <Error technicalError={technicalError} kind="products" />;
  }

  render() {
    return (
      <div ref={el => (this.element = el)} className="cm-products">
        <h2 className="cm-products--title">
          <FormattedHTMLMessage id="classes_list" />
        </h2>
        <div className="cm-products--outer">{this.renderProducts()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Products.js